/*
 * @Author: Json Chen
 * @Date: 2021-07-13 17:43:48
 * @LastEditTime: 2022-05-24 16:45:28
 * @LastEditors: Teemo Ding
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Components/SelectCountryArea.tsx
 */
import { Filter } from '@/src/components';
import CheckboxList from '@/src/components/CheckboxList';
import { Checkbox, Collapse } from 'antd';
import _, { get } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';

import { getStoreCountries } from '@/src/request/settings';
import { useRequest } from 'ahooks';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import styles from './style.module.less';

const CheckArea = ({ value, onChange, itemKey, list, showIndexs, search }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [actives, setActives] = useState([]);
  const onCheckAllChange = ({ target }, item) => {
    const checked = target.checked;
    onChange({ item, checked, type: 'country' });
  };

  const onCheckItemChange = (v, item) => {
    onChange({
      item: {
        country: item.country,
        subdivisions: v,
      },
      type: 'area',
    });
  };

  const onCollapseChange = (v) => {
    setActives(v);
  };

  useEffect(() => {
    if (showIndexs) {
      const searchResActiveKeys = Object.keys(showIndexs).map((i) => Number(i));
      setActives([...new Set([...searchResActiveKeys, ...actives])]);
    }
  }, [showIndexs]);

  return search && !showIndexs ? (
    <div className={styles.noResult}>
      {replaceI18nVariables(getI18n('general.noresultforsearch'), search)}
    </div>
  ) : (
    <Collapse
      expandIconPosition='right'
      activeKey={actives}
      onChange={onCollapseChange}>
      {list.map((item, index) => {
        const { country, subdivisions = [] } = item;

        const _subdivisions = subdivisions || [];
        console.log('_subdivisions: ', _subdivisions);
        console.log('---value: ', value);
        const same = (value || []).find(
          (v) => _.get(v, itemKey) === _.get(item, itemKey),
        );

        const samevalues = (same || {}).subdivisions || [];
        console.log('samevalues: ', samevalues);

        const calcShowByIndexs = showIndexs ? showIndexs[index] || [] : [];

        const show = showIndexs ? !!calcShowByIndexs.length : true;

        return (
          <Collapse.Panel
            className={show ? styles.show : styles.hide}
            header={
              <div className={styles.collapseContent}>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                  }}>
                  <Checkbox
                    indeterminate={
                      same &&
                      (same.subdivisions || []).length < _subdivisions.length
                    }
                    onChange={(e) => onCheckAllChange(e, item)}
                    checked={
                      same &&
                      (same.subdivisions || []).length === _subdivisions.length
                    }>
                    {country.description}
                  </Checkbox>
                </div>
                {samevalues.length ? (
                  <div className={styles.samevalues}>
                    {`${samevalues.length} / ${_subdivisions.length}`}
                  </div>
                ) : null}
              </div>
            }
            key={index}>
            <CheckboxList
              className={styles.listItem}
              value={samevalues}
              onChange={(v) => onCheckItemChange(v, item)}
              renderItem={(subItem: any) => <span>{subItem.name}</span>}
              itemKey={'uuid'}
              list={_subdivisions}
              showIndexs={calcShowByIndexs}
            />
          </Collapse.Panel>
        );
      })}
    </Collapse>
  );
};

export const CheckCountry = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { value: checks = [], onChange: setChecks, list = [] } = props;
  // 全部数据
  const [_searchValue, _setSearchValue] = React.useState<string>('');
  const [searchValue, setSearchValue] = React.useState<string>('');
  const [checkAll, setCheckAll] = useState<boolean>(false);

  const itemKey = 'country.code';

  // const [indeterminate, setIndeterminate] = useState<boolean>(false);
  const indeterminate = useMemo(() => {
    if (checks.length) {
      if (checks.length < list.length) {
        return true;
      } else {
        // length 相等,需要判断 subdivisions
        return checks.some((c) => {
          // 找到list中相同的项
          const same =
            list.find((i) => _.get(i, itemKey) === _.get(c, itemKey)) || {};
          return (
            (c.subdivisions || []).length < (same.subdivisions || []).length
          );
        });
      }
    } else {
      return false;
    }
  }, [checks]);

  const search = useMemo(() => searchValue.trim(), [searchValue]);

  const showIndexs = useMemo(() => {
    let _showIndexs = null;
    const _searchValue = searchValue.trim().toLowerCase();
    if (_searchValue) {
      for (let i = 0; i < list.length; i++) {
        const countries = list[i].country || {};
        const subdivisions = list[i].subdivisions || [];
        //国家名称
        if (countries.name.toLowerCase().includes(_searchValue)) {
          let allIndex = [];
          for (let j = 0; j < subdivisions.length; j++) {
            allIndex = allIndex.concat(j);
          }
          if (_showIndexs) {
            if (_showIndexs[i]) {
              _showIndexs[i] = _showIndexs[i].concat(allIndex);
            } else {
              _showIndexs[i] = allIndex;
            }
          } else {
            _showIndexs = {
              [i]: allIndex,
            };
          }
        }

        for (let j = 0; j < subdivisions.length; j++) {
          if (subdivisions[j].name.toLowerCase().includes(_searchValue)) {
            if (_showIndexs) {
              if (_showIndexs[i]) {
                _showIndexs[i] = _showIndexs[i].concat(j);
              } else {
                _showIndexs[i] = [j];
              }
            } else {
              _showIndexs = {
                [i]: [j],
              };
            }
          }
        }
      }
    }
    return _showIndexs;
  }, [searchValue]);

  console.log(showIndexs, 'showIndexs============>');

  const onCheckAllChange = ({ target }) => {
    const checked = target.checked;
    if (checked) {
      setChecks(list);
    } else {
      setChecks([]);
    }
    setCheckAll(checked);
  };

  const onSearchChange = (v) => {
    _setSearchValue(v);
  };

  const onCheckChange = ({ item, checked, type }) => {
    const checkedIndex = (checks || []).findIndex(
      (v) => _.get(v, itemKey) === _.get(item, itemKey),
    );

    let checkedItems;
    let newChecks = [];
    switch (type) {
      case 'country':
        checkedItems = checked;
        break;
      case 'area':
        checkedItems = !!item.subdivisions.length;
        break;
    }
    if (checkedItems) {
      if (checkedIndex > -1) {
        newChecks = checks.map((c, i) => {
          return i === checkedIndex ? item : c;
        });
      } else {
        // 还未存在
        newChecks = checks.concat(item);
      }
    } else {
      newChecks = checks.filter((_, i) => i !== checkedIndex);
    }

    const isAllChecked =
      newChecks.length === list.length &&
      list.every((i) => {
        const same =
          newChecks.find((c) => _.get(c, itemKey) === _.get(i, itemKey)) || {};
        return (
          (i.subdivisions || []).length === (same.subdivisions || []).length
        );
      });
    setCheckAll(isAllChecked);
    setChecks(newChecks);
  };
  const onPressEnter = (e) => {
    setSearchValue(e.target.value);
  };
  return (
    <div className={styles.countryAreaContainer}>
      <div className={styles.countryAreaFilterLabel}>
        {getI18n('general.selectcountryarea')}*
      </div>
      <Filter
        searchValue={_searchValue}
        searchOnchange={onSearchChange}
        pressEnter={onPressEnter}
        onSearch={setSearchValue}
        className={styles.filterSearch}
      />
      <div className={styles.countryAreaCheckBox}>
        <Checkbox
          indeterminate={indeterminate}
          checked={checkAll}
          onChange={onCheckAllChange}>
          {getI18n('general.countryandArea')}
        </Checkbox>
      </div>

      <CheckArea
        value={checks}
        onChange={onCheckChange}
        itemKey={itemKey}
        list={list}
        showIndexs={showIndexs}
        search={search}
      />
    </div>
  );
};

export const useStoreCountries = () => {
  const { loading, data: list = [] } = useRequest(getStoreCountries, {
    cacheKey: 'StoreCountries',
  });

  return {
    loading,
    list,
  };
};

interface Country {
  areaCode: string;
  code: string;
  description: string;
  longCode: string;
  name: string;
  subdivisionCount: string;
  subdivisionTitle: string;
}

interface Province {
  areaCode: string;
  category: string;
  code: string;
  countryCode: string;
  name: string;
  uuid: string;
}
export interface CountryArea {
  country: Country;
  subdivisions: Province[] | null;
}

/*
 *
 * @param {CountryAreas[]} value 已选的地区信息
 * @param {CountryAreas[]} list 所有的地区信息
 * @returns {string} 返回计算后的字符串
 */
export const useCalcAreaText = (values: CountryArea[], list: CountryArea[]) => {
  const text = useMemo(() => {
    return values
      .reduce((p, c) => {
        const base = list.find((i) => i.country.code === c.country.code);
        const bLen = (base.subdivisions || []).length;
        const cLen = (c.subdivisions || []).length;
        const unit = get(c, ['subdivisions', 0, 'category']);

        // TODO: c.subdivisions.length 不应该为0,由于现在缺少数据,导致 c.subdivisions 拿到的是null; 之后 !cLen 条件可以去掉
        if (bLen === cLen || !cLen) {
          return p.concat(c.country.name);
        }
        return p.concat(
          `${c.country.name}  (${cLen} / ${bLen} ${unit}: ${c.subdivisions
            .map((item) => item.name)
            .join(',')})`,
        );
      }, [])
      .join(',');
  }, [values, list]);
  return text;
};
